import React, { useCallback } from 'react';

import { Col, Row } from 'antd';

import { NEWPRODUCT_URL } from 'settings';
import { useGetBetaFeatures } from 'v2/hooks/useGetBetaFeatures';
import { usePostMessage } from 'v2/hooks/usePostMessage';
import { PostMessageAction, PostMessageSource } from 'v2/interfaces/post-message';

const BETA_FEATURE_KEY = 'ai_product_creation';

const REDIRECT_ROOT_BACKGROUND = `radial-gradient(circle at 100% 100%, #ffffff 0, #ffffff 7px, transparent 7px) 0% 0%/8px 8px no-repeat,
  radial-gradient(circle at 0 100%, #ffffff 0, #ffffff 7px, transparent 7px) 100% 0%/8px 8px no-repeat,
  radial-gradient(circle at 100% 0, #ffffff 0, #ffffff 7px, transparent 7px) 0% 100%/8px 8px no-repeat,
  radial-gradient(circle at 0 0, #ffffff 0, #ffffff 7px, transparent 7px) 100% 100%/8px 8px no-repeat,
  linear-gradient(#ffffff, #ffffff) 50% 50%/calc(100% - 2px) calc(100% - 16px) no-repeat,
  linear-gradient(#ffffff, #ffffff) 50% 50%/calc(100% - 16px) calc(100% - 2px) no-repeat,
  linear-gradient(98deg, #7b5de6 25.21%, #de8fe9 46%, #fbb5c0 71%)`;

function ShinyIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' style={{ minWidth: '24px' }} width='24' height='24' fill='none'>
      <path
        fill='url(#a)'
        d='m21.303 12.174-5.638-1.066a3.042 3.042 0 0 1-2.424-2.424l-1.066-5.638-1.067 5.638a3.043 3.043 0 0 1-2.425 2.424l-5.638 1.066 5.638 1.067a3.044 3.044 0 0 1 2.425 2.425l1.066 5.637 1.067-5.637a3.042 3.042 0 0 1 2.424-2.425l5.638-1.067Zm2.031.001a2.03 2.03 0 0 1-1.657 1.994l-5.634 1.065a1.018 1.018 0 0 0-.81.808l-1.065 5.635a2.03 2.03 0 0 1-3.29 1.19 2.03 2.03 0 0 1-.698-1.19l-1.065-5.634a1.017 1.017 0 0 0-.809-.809l-5.635-1.066a2.027 2.027 0 0 1-.172-3.947l.172-.04 5.635-1.066a1.017 1.017 0 0 0 .809-.808l1.066-5.638a2.028 2.028 0 0 1 3.987 0l1.066 5.637a1.017 1.017 0 0 0 .809.81l5.634 1.065a2.032 2.032 0 0 1 1.657 1.994Z'
      />
      <path
        fill='url(#b)'
        d='M19.275 6.086V5.072H18.26a1.014 1.014 0 0 1 0-2.028h1.014V2.03a1.014 1.014 0 0 1 2.029 0v1.014h1.014a1.015 1.015 0 0 1 0 2.028h-1.014v1.014a1.015 1.015 0 1 1-2.03 0Z'
        opacity='.769'
      />
      <path
        fill='url(#c)'
        d='M5.075 20.289a1.015 1.015 0 1 0-2.03 0 1.015 1.015 0 0 0 2.03 0Zm2.029 0a3.043 3.043 0 1 1-6.087 0 3.043 3.043 0 0 1 6.087 0Z'
        opacity='.942'
      />
      <defs>
        <linearGradient id='a' x1='7.073' x2='18.776' y1='3.805' y2='5.589' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#7B5DE6' />
          <stop offset='.457' stopColor='#DE8FE9' />
          <stop offset='1' stopColor='#FBB5C0' />
        </linearGradient>
        <linearGradient id='b' x1='7.073' x2='18.776' y1='3.805' y2='5.589' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#7B5DE6' />
          <stop offset='.457' stopColor='#DE8FE9' />
          <stop offset='1' stopColor='#FBB5C0' />
        </linearGradient>
        <linearGradient id='c' x1='7.073' x2='18.776' y1='3.806' y2='5.589' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#7B5DE6' />
          <stop offset='.457' stopColor='#DE8FE9' />
          <stop offset='1' stopColor='#FBB5C0' />
        </linearGradient>
      </defs>
    </svg>
  );
}

function BookIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none'>
      <path
        fill='#0D2772'
        d='M1.25 3.534c1.106-.463 2.692-.96 4.235-1.116 1.662-.168 3.073.079 3.89.94V15.54c-1.169-.663-2.65-.754-4.016-.616-1.475.15-2.962.577-4.109 1.014V3.534Zm9.375-.176c.817-.861 2.227-1.108 3.89-.94 1.543.156 3.129.653 4.235 1.116v12.404c-1.147-.437-2.634-.865-4.11-1.014-1.366-.138-2.846-.047-4.015.616V3.358ZM10 2.228C8.769 1.17 6.984 1.01 5.36 1.174c-1.893.191-3.804.84-4.994 1.381a.625.625 0 0 0-.366.57v13.75a.625.625 0 0 0 .884.568c1.102-.5 2.879-1.101 4.6-1.275 1.76-.177 3.238.109 4.028 1.097a.625.625 0 0 0 .976 0c.79-.988 2.267-1.274 4.027-1.097 1.722.174 3.5.774 4.601 1.275a.625.625 0 0 0 .884-.569V3.124a.625.625 0 0 0-.366-.569c-1.19-.54-3.1-1.19-4.993-1.38C13.017 1.01 11.23 1.17 10 2.227Z'
      />
    </svg>
  );
}

function AIButtonRedirect() {
  const { data: betaFeatures } = useGetBetaFeatures();
  const sendPostMessage = usePostMessage();
  const aiProductCreationIsActive = betaFeatures?.includes(BETA_FEATURE_KEY);

  const onClick = useCallback(() => {
    sendPostMessage({
      source: PostMessageSource.PRODUCT_MANAGER,
      action: PostMessageAction.CLICK_BUTTON_FIGUEIRA,
      data: { date: new Date().toISOString() }
    });
  }, [sendPostMessage]);

  if (!aiProductCreationIsActive) return null;

  return (
    <Row gutter={[16, 16]} className='mt-20 mb-20'>
      <Col span={24}>
        <div className='flex items-center gap-2'>
          <ShinyIcon />
          <span className='text-base font-medium'>
            Estamos testando um novo formato de cadastro de e-books com apoio de Inteligência Artificial. Quer
            experimentar?
          </span>
        </div>
      </Col>
      <Col sm={24} md={8} xs={24}>
        <a
          href={NEWPRODUCT_URL}
          target='_blank'
          className='box-border flex cursor-pointer flex-col rounded-lg p-4 [&>div]:grow'
          style={{ background: REDIRECT_ROOT_BACKGROUND }}
          rel='noreferrer'
          onClick={onClick}
        >
          <div className='mb-2 flex items-center gap-2 font-medium text-black'>
            <BookIcon />
            <span className='text-base font-medium'>Apoio inteligente</span>
          </div>
          <div className='text-grey-400 text-sm leading-normal'>
            <span>Use a IA para receber sugestões e orientações durante o cadastro do seu e-book.</span>
          </div>
        </a>
      </Col>
    </Row>
  );
}

export default AIButtonRedirect;
